// src/api/services/authService.js
import axiosInstance from "./axiosInstance";
import { API_ENDPOINTS } from "./endpoint";

export const loginUser = async (credentials) => {
  const response = await axiosInstance.post(
    API_ENDPOINTS.LOGIN,
    credentials
  );
  return response.data;
};

export const registerUser = async (userData) => {
  const response = await axiosInstance.post(
    API_ENDPOINTS.REGISTER,
    userData
  );
  return response.data;
};

export const verifyUser = async () => {
  const response = await axiosInstance.get("/verify");

  return response.data;
};
export const changePassword = async (data) => {
  const response = await axiosInstance.put(
    "/change-password",
    data
  );

  return response.data;
};

export const verifyMfaLogin = async (challengeToken, token) => {
  const response = await axiosInstance.post(
    "/auth/mfa/verify",
    {
      challengeToken,
      token,
    }
  );
  return response.data;
};
